import authService from '../services/authService'
import { sessionStore } from '../../common/services/storageService'
export default {
    state: {
        loggedUser: null,
        authError: ''
    },
    getters: {
        loggedUser(state) {
            return state.loggedUser;
        },
        authErrorMsg(state) {
            return state.authError
        }
    },
    mutations: {
        setLoggedUser(state, { user }) {
            state.loggedUser = user;
            const { email } = user
            sessionStore('loggedUser', { email })
        },
        setAuthError(state, { error }) {
            state.authError = error;
        },
    },
    actions: {
        async login(context, {credentials}) {
            try {
                const user = await authService.login(credentials)
                context.commit({type:'setAuthError', error: ''})
                context.commit({type: 'setLoggedUser', user})
                return user
            } catch(err) {
                // Store stable error code for i18n in Login.vue (not a raw English string)
                context.commit({
                    type: 'setAuthError',
                    error: (err && (err.code || err.message)) || 'LOGIN_FAILED',
                })
            }
        },
        async getLoggedInUser(context) {
            try {
                const user = await authService.getLoggedInUser();
                context.commit({type: 'setLoggedUser', user})
                return user;
            } catch(err) {
                //handle UI error
            }
        }
    }
}
